import styled from "styled-components";
import { Search, Plus } from 'lucide-react';
import { useState } from "react";

interface ITopActions {
    filter: string,
    quantity: string,
    handleAddNew: ()=>void,
    filtrar: (filter: string, quantity: string)=>void,
    disabled?: boolean
}
export const TopActions = ({ handleAddNew, filter, quantity, filtrar, disabled = false }: ITopActions) => {
    const [internalFilter, setInternalFilter] = useState(filter)
    const [internalQuantity, setInternalQuantity] = useState(quantity)

    const handleKeyDown = (event: { key: string; }) => {
        if (event.key === 'Enter') {
            filtrar(internalFilter,internalQuantity)
        }
      };

    return (
        <TopActionsComponent>
            <Button variant="primary" onClick={handleAddNew} disabled={disabled}>
                <Plus size={16} />
                Incluir novo registro
            </Button>

            <FilterContainer>
                <SearchInput>
                    <Search size={16} color="#999" />
                    <input
                        type="text"
                        placeholder="Filtro"
                        value={internalFilter}
                        onChange={(e) => setInternalFilter(e.target.value)}
                        onKeyDown={handleKeyDown}
                    />
                </SearchInput>

                <QuantityInput>
                    <span>Quantidade</span>
                    <input
                        type="number"
                        value={internalQuantity}
                        onChange={(e) => setInternalQuantity(e.target.value)}
                        onKeyDown={handleKeyDown}
                    />
                </QuantityInput>

                <Button onClick={() => filtrar(internalFilter, internalQuantity)}>Filtrar</Button>
                <Button onClick={() => {
                    setInternalFilter('');
                    setInternalQuantity('13');
                }}>Limpar</Button>
            </FilterContainer>
        </TopActionsComponent>
    )
}

const breakpoints = {
    mobile: '480px',
    tablet: '768px',
    laptop: '1024px'
};

const TopActionsComponent = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 20px;
    gap: 16px;
    flex-wrap: wrap;

    @media (max-width: ${breakpoints.tablet}) {
        flex-direction: column;
        align-items: stretch;
    }
`;

const Button = styled.button<{ variant?: 'primary' | 'secondary' }>`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 16px;
    border-radius: 4px;
    border: none;
    cursor: pointer;
    font-size: 14px;
    transition: background-color 0.2s;
    white-space: nowrap;

    background-color: ${props => props.theme.cores.btn.primaria};
    color: ${props => props.theme.cores.textoWhite};

    &:hover {
        background-color: ${props => props.theme.cores.btn.houver.primaria};
    }

    @media (max-width: ${breakpoints.mobile}) {
        width: 100%;
        justify-content: center;
    }
`;

const FilterContainer = styled.div`
    display: flex;
    gap: 16px;
    align-items: center;
    flex-wrap: wrap;

    @media (max-width: ${breakpoints.tablet}) {
        width: 100%;
    }

    @media (max-width: ${breakpoints.mobile}) {
        flex-direction: column;
        gap: 8px;
    }
`;

const SearchInput = styled.div`
    display: flex;
    align-items: center;
    background: white;
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 4px 12px;
    flex: 1;
    min-width: 200px;

    input {
        border: none;
        padding: 4px;
        width: 100%;
        outline: none;
    }

    @media (max-width: ${breakpoints.mobile}) {
        width: 100%;
    }
`;

const QuantityInput = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    
    input {
      width: 60px;
      padding: 6px;
      border: 1px solid #ddd;
      border-radius: 4px;
    }
  
    @media (max-width: ${breakpoints.mobile}) {
      width: 100%;
      justify-content: space-between;
      
      input {
        width: 100px;
      }
    }
`;